import React from 'react';
import { Globe, MapPin } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const Header = ({ countries, selectedCountry, setSelectedCountry, bases, selectedBase, setSelectedBase }) => {
  const { getThemeClasses } = useTheme();
  const themeClasses = getThemeClasses();

  return (
    <div className={`${themeClasses.secondary} border-b ${themeClasses.border} px-6 py-4`}>
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-2 flex-1">
          <Globe size={20} className={themeClasses.textAccent} />
          <select
            value={selectedCountry}
            onChange={(e) => {
              setSelectedCountry(e.target.value);
              setSelectedBase('all');
            }}
            className={`${themeClasses.input} ${themeClasses.textPrimary} px-4 py-2 rounded-lg border ${themeClasses.borderInput} ${themeClasses.borderFocus} focus:outline-none focus:ring-2 focus:ring-military-500 cursor-pointer`}
          >
            <option value="global">Global Overview</option>
            {countries.map((country) => (
              <option key={country.id} value={country.id}>
                {country.name}
              </option>
            ))}
          </select>
        </div>

        {selectedCountry !== 'global' && (
          <div className="flex items-center gap-2 flex-1">
            <MapPin size={20} className={themeClasses.textAccent} />
            <select
              value={selectedBase}
              onChange={(e) => setSelectedBase(e.target.value)}
              className={`${themeClasses.input} ${themeClasses.textPrimary} px-4 py-2 rounded-lg border ${themeClasses.borderInput} ${themeClasses.borderFocus} focus:outline-none focus:ring-2 focus:ring-military-500 cursor-pointer w-full`}
            >
              <option value="all">All Bases</option>
              {bases.map((base) => (
                <option key={base.id} value={base.id}>
                  {base.name}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="flex gap-2">
          <button
            onClick={() => {
              setSelectedCountry('global');
              setSelectedBase('all');
            }}
            className="px-4 py-2 bg-military-700/50 text-white rounded-lg hover:bg-military-600 transition-colors border border-military-600/30"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
